import React from 'react';

export const donaldTrump = {
  presidentNumber: 45,
  president: 'Donald Trump',
  subheader: 'Make America Great Again',
  years: '2017-2021',
  predecessor: 'Barack Obama',
  successor: 'Joe Biden',
  letter: {
    header: 'Letter to Joe Biden',
    content: `Joe,
I leave you a presidency that has been under assault from Day One by the Deep State, Fake News Media, and Radical Left Democrats who could never accept that the American People chose an outsider over the corrupt Washington establishment. Despite this unprecedented witch hunt, we achieved the greatest economy in history, rebuilt our military, and restored respect for America around the world.

The China Trade Deal was the greatest deal ever negotiated, bringing back manufacturing jobs and ending decades of unfair trade practices that ripped off American workers. We moved our embassy to Jerusalem, achieved historic peace agreements in the Middle East, and made NATO pay their fair share for the first time.

The Wall we built on our Southern Border ended the invasion of drugs, criminals, and illegal aliens that previous administrations allowed to destroy American communities. We became energy independent and ended the endless wars that drained our treasury and our blood.

The Fake Impeachments and Russia Hoax were nothing but partisan attempts to overturn the will of the American People. History will vindicate our America First policies and expose the corruption of our political and media establishments.

The 2020 Election was rigged and stolen through massive fraud, unconstitutional changes to election laws, and Big Tech censorship. The American People know the truth, and this will be remembered as the greatest crime in political history.

We made America Great Again, and the movement we started will continue long after the swamp creatures have been drained.

Donald J. Trump The Real President`
  },
  biographical: [
    'Born June 14, 1946, in Queens, New York',
    'Served one term, January 20, 2017 – January 20, 2021',
    'First president without prior military or government service',
    'Previously worked as businessman and reality TV host',
    'Lost reelection to Joe Biden in 2020'
  ],
  presidencyFacts: [
    'Implemented significant tax cuts and deregulation',
    'Appointed three Supreme Court justices',
    'Imposed tariffs on China and other trading partners',
    'Withdrew from Paris Climate Agreement',
    'Faced two impeachment trials'
  ],
  milestones: [
    'Tax Cuts and Jobs Act passed (2017)',
    'U.S. withdrew from Paris Climate Agreement (2017)',
    'First impeachment trial (2019-2020)',
    'COVID-19 pandemic began (2020)',
    'Second impeachment trial (2021)'
  ],
  personalLife: [
    'Married three times: Ivana, Marla, and Melania',
    'Has five children from three marriages',
    'Oldest person elected president at age 70',
    'Continues to be politically active after presidency',
    'Faces multiple legal challenges'
  ],
  impactAndLegacy: [
    'Transformed Republican Party platform and priorities',
    'Appointed conservative judges to federal courts',
    'Changed U.S. trade and immigration policies',
    'Faced unprecedented impeachment proceedings',
    'Contested 2020 election results'
  ],
  postPresidency: [
    'Refused to attend Biden\'s inauguration',
    'Faces multiple criminal and civil legal cases',
    'Remains active in Republican Party politics',
    'Announced 2024 presidential campaign',
    'Continues to claim 2020 election was stolen'
  ],
  historicalAnalysis: `Donald Trump's presidency disrupted traditional American politics through populist appeals and norm-breaking behavior while achieving some policy successes, ultimately ending with electoral defeat and unprecedented challenges to democratic transitions.

[SECTION] Economic Policy and Deregulation

The Tax Cuts and Jobs Act (2017) reduced corporate and individual tax rates while eliminating some deductions, providing stimulus that contributed to economic growth. Aggressive deregulation across industries, including finance, energy, and environment, reduced compliance costs for businesses while raising concerns about consumer and environmental protection.

Pre-pandemic economic performance included low unemployment, strong stock market gains, and moderate growth, though economists debate the relative impact of Trump policies versus inherited trends.

[SECTION] Trade Policy and International Economics

Trump's trade wars with China, involving tariffs on hundreds of billions of dollars in goods, aimed to reduce trade deficits and bring manufacturing jobs back to America. The renegotiation of NAFTA into the United States-Mexico-Canada Agreement (USMCA) updated trade rules while maintaining basic free trade principles.

Withdrawal from the Trans-Pacific Partnership and other multilateral trade agreements reduced American economic leadership while potentially benefiting competitors.

[SECTION] Immigration and Border Security

Trump's immigration policies emphasized border security, deportation enforcement, and reduced legal immigration through administrative changes and travel restrictions. The construction of border wall sections fulfilled a central campaign promise while creating controversy over funding, effectiveness, and environmental impact.

Family separation policies at the border created humanitarian crises and legal challenges while the "Remain in Mexico" program for asylum seekers faced implementation difficulties.

[SECTION] Foreign Policy and America First

Trump's foreign policy challenged post-World War II alliances and institutions while pursuing bilateral negotiations and reduced military commitments. The withdrawal from the Iran Nuclear Deal and Paris Climate Agreement reversed Obama administration policies while isolating America from allied positions.

The Abraham Accords normalized relations between Israel and several Arab states, representing a significant Middle East diplomatic achievement. Relations with traditional allies, particularly in Europe, were strained by criticism of NATO, trade disputes, and disagreements over multilateral institutions.

[SECTION] COVID-19 Pandemic Response

The COVID-19 pandemic dominated Trump's final year, testing federal crisis management capabilities and revealing institutional weaknesses in public health systems. Operation Warp Speed accelerated vaccine development through public-private partnerships, achieving remarkable scientific success in record time.

However, inconsistent messaging about public health measures, conflicts with medical experts, and politicization of the pandemic response undermined public confidence and may have cost lives. The economic response included massive spending through the CARES Act and other measures that prevented deeper recession but increased federal debt significantly.

[SECTION] Judicial Appointments and Legal Legacy

Trump's appointment of three Supreme Court justices—Neil Gorsuch, Brett Kavanaugh, and Amy Coney Barrett—created a conservative majority that will influence American law for decades. The confirmation of over 200 federal judges represented perhaps Trump's most lasting domestic legacy, moving courts in a more conservative direction.

The contentious confirmation battles, particularly for Kavanaugh and Barrett, intensified partisan conflicts over judicial appointments and constitutional interpretation.

[SECTION] Impeachment and Constitutional Crises

Trump became the first president impeached twice, first for pressuring Ukraine to investigate Joe Biden and second for inciting the January 6 Capitol insurrection. The Ukraine impeachment reflected broader concerns about presidential abuse of power and foreign interference in American elections.

Senate acquittals in both cases followed largely partisan votes, highlighting the difficulty of holding presidents accountable through constitutional mechanisms.

[SECTION] Social Media and Political Communication

Trump's extensive use of Twitter and social media fundamentally changed presidential communication, bypassing traditional media while spreading unverified information. His attacks on "fake news" and mainstream media undermined public confidence in traditional journalism while elevating alternative information sources.

The deplatforming of Trump from major social media sites raised questions about corporate power and free speech in the digital age.

[SECTION] 2020 Election and Democratic Norms

Trump's refusal to accept his electoral defeat and claims of widespread fraud without evidence represented unprecedented challenges to democratic transitions. The January 6, 2021 attack on the Capitol, following Trump's rally contesting the election results, resulted in multiple deaths and threatened the peaceful transfer of power.

Numerous lawsuits challenging election results were rejected by courts, including Trump-appointed judges, while election officials from both parties confirmed the integrity of the electoral process.

[SECTION] Political Polarization and Cultural Divisions

Trump's presidency intensified political polarization through divisive rhetoric and policies that appealed to his base while alienating opponents. His response to racial justice protests and white supremacist activities created concerns about presidential leadership on civil rights and social unity.

The "America First" movement he led continues to influence Republican politics and conservative positions on immigration, trade, and foreign policy.

[SECTION] Administrative Turnover and Governance

Unprecedented turnover in cabinet and senior positions, often accompanied by public disputes and firings, raised questions about administrative competence and stability. The use of "acting" officials to avoid Senate confirmation created legal challenges and undermined institutional authority.

Conflicts between Trump and career federal employees, including intelligence and law enforcement officials, strained traditional civil service norms.

[SECTION] Economic Impact and Legacy

Pre-pandemic economic growth and low unemployment supported Trump's claims of economic success, though the pandemic recession complicated assessments of his economic legacy. The combination of tax cuts and increased spending created large federal deficits that will constrain future policy options.

[SECTION] Historical Assessment

Historical evaluation of Trump's presidency is complicated by its recency and the unprecedented nature of many events during his administration. Early scholarly assessments have been largely critical, focusing on norm-breaking behavior and challenges to democratic institutions while acknowledging some policy achievements.

Trump's continued influence in Republican politics and claims about the 2020 election suggest that full historical assessment may require more time and perspective. The Trump presidency raises fundamental questions about democratic institutions, presidential power, and the resilience of American constitutional government.`,
  sources: [
    '[LINK:https://millercenter.org/president/trump/impact-and-legacy|Miller Center, University of Virginia. "Donald Trump: Impact and Legacy." Accessed 2025.]',
    '[LINK:https://www.history.com/topics/us-presidents/donald-trump|History.com. "Donald Trump: Facts, Presidency & Quotes." Updated February 2025.]',
    '[LINK:https://www.whitehousehistory.org/bios/donald-trump|White House Historical Association. "Donald Trump." Accessed 2025.]',
    '[LINK:https://en.wikipedia.org/wiki/Presidency_of_Donald_Trump|Wikipedia. "Presidency of Donald Trump." Updated 2025.]',
    '[LINK:https://us.macmillan.com/books/9781250158062/fireandfury|Wolff, Michael. Fire and Fury: Inside the Trump White House. Henry Holt, 2018.]',
    '[LINK:https://www.simonandschuster.com/books/The-Room-Where-It-Happened/John-Bolton/9781982148034|Bolton, John. The Room Where It Happened: A White House Memoir. Simon & Schuster, 2020.]',
    '[LINK:https://www.simonandschuster.com/books/Fear/Bob-Woodward/9781501175510|Woodward, Bob. Fear: Trump in the White House. Simon & Schuster, 2018.]'
  ]
};

export default donaldTrump;